// Device frames around real app screenshots.

export function Screen({ src, alt, url = "app/invoice", className = "", eager }) {
  return (
    <div className={`overflow-hidden rounded-2xl bg-white shadow-[0_40px_100px_-30px_rgba(15,23,42,0.45)] ring-1 ring-slate-900/10 ${className}`}>
      <div className="flex items-center gap-2 border-b border-slate-100 bg-slate-50/90 px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-[#ff5f57]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#febc2e]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#28c840]" />
        <span className="ml-3 hidden flex-1 truncate rounded-md bg-white px-3 py-1 text-center text-[11px] text-slate-400 ring-1 ring-slate-200 sm:block">{url}</span>
      </div>
      <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} className="block w-full" width={1600} height={1000} />
    </div>
  );
}

export function Phone({ src, alt, className = "" }) {
  return (
    <div className={`relative w-[230px] rounded-[2.4rem] bg-slate-900 p-2.5 shadow-[0_40px_80px_-30px_rgba(15,23,42,0.6)] ring-1 ring-slate-700 ${className}`}>
      <div className="absolute left-1/2 top-3.5 z-10 h-5 w-20 -translate-x-1/2 rounded-full bg-slate-900" />
      <div className="overflow-hidden rounded-[1.9rem] bg-white">
        <img src={src} alt={alt} loading="lazy" className="block w-full" width={640} height={1385} />
      </div>
    </div>
  );
}
